import { createComponent, createElement } from "@vue/composition-api";
import { RevisionItem } from "@megarax/client/src/resources/RevisionItem";
import { useActions } from "@/shared/useMegaraxClient";
import router from "@/router";
import { RevisionActions } from "@megarax/client/src/revision";
import { ResourceAppModule } from "@/shared/app";
import { getModulePath } from "@/apps/getPath";

import ActionButton from "@/components/ActionButton.vue";
import { ResourceItem } from "@megarax/client/src/resources/ResourceItem";
import { useAsyncRef } from "@/shared/useAsyncRef";
import { useResourceProvider } from "../../shared/useResourceProvider";
import { meResource } from "@megarax/iam/restApi";

interface Props {
  value: RevisionItem;
  module: ResourceAppModule<RevisionActions<any, any>>;
}

export default createComponent<Props>({
  name: "RevisionDuplicateButton",
  props: {
    value: {
      required: true,
    },
    module: {
      required: true,
    },
  },
  setup(props, ctx) {
    const actions = useActions(props.module.resource);

    const meResourceProvider = useResourceProvider(meResource);

    const canUse = useAsyncRef<boolean>(() =>
      meResourceProvider.isAllowed({
        action: [actions.appName, actions.service, "duplicate"].join("."),
      }),
    );

    async function onResponse(duplicated: ResourceItem) {
      router.push(getModulePath(props.module, duplicated.id));
    }

    return () =>
      canUse.value
        ? createElement(
            ActionButton,
            {
              props: {
                action: () => actions.duplicateItem(props.value),
                successMessage: "Utworzono kopię roboczą.",
              },
              attrs: { ...ctx.attrs, icon: "el-icon-document-copy" },
              on: {
                ...ctx.listeners,
                response: onResponse,
              },
            },
            ["Utwórz kopię roboczą"],
          )
        : null;
  },
});
